// extracted by mini-css-extract-plugin
export default {"ul":"Dropdown_ul__dKGdm","ul-open":"Dropdown_ul-open__3xacQ"};